export default {"src":"/_next/static/media/OSCR.29d0d4ed.svg","height":18,"width":18};